<template lang="pug">
  .simple.search-page
    slot(name="header")
    main(v-if="areas.main && areas.main.length")
      section(
        v-for="(section, index) in areas.main"
        :key="section.id"
        :class="section.key"
      )
        ProductSearchResults(v-if="section.key === 'product-search-results'" :section="section")
    slot(name="footer")
</template>

<script>
import Page from '@/views/Page';
import ProductSearchResults from '@/extensions/shop/components/SearchResults';

export default {
    name: 'Search',
    extends: Page,
    components: {
        ProductSearchResults
    }
};
</script>

<style lang="sass">
.simple.search-page,
.simple.search-page main
  @apply flex
  flex-direction: column
  flex-grow: 1

.simple.search-page
  main
    padding: 1rem
    @screen lg
      padding: 1rem 3rem
      padding-bottom: calc(50px + 1rem)
    .searching
      @apply flex
      flex-grow: 1
</style>
